export default "images/technical2.png";